export default __webpack_public_path__ + "assets/wechat-consultation-qr.fa7c6395.png";